import backend, {ONBOARDING_API} from 'utils/backend/server/api_library';

class OnboardingWebsocketManager {
  constructor(onMessage, onOpen, onError, onClose) {
    this.ws = null;
    this.url = process.env.REACT_APP_ONBOARDING_WEBSOCKET;

    this.onMessage = onMessage;
    this.onOpen = onOpen;
    this.onError = onError;
    this.onClose = onClose;
  }

  connect() {
    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      this.onOpen();
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.onMessage?.(data);
      } catch (e) {
        console.error('Error parsing WebSocket message', e);
      }
    };

    this.ws.onerror = (event) => {
      console.error('WebSocket error:', event);
      this.onError?.(event);
    };

    this.ws.onclose = () => {
      this.onClose?.();
    };
  }

  send(data) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data));
    } else {
      console.warn('WebSocket is not open. Cannot send message.');
    }
  }

  close() {
    this.ws?.close();
  }
}

const fetchFormData = async (clientRn) => {
  const url = `${ONBOARDING_API}/onboarding_chatbot/${clientRn}/get_form`;
  const response = await backend.get(url);
  return response;
};

const updateParameter = async (clientRn, values) => {
  const url = `${ONBOARDING_API}/onboarding_chatbot/${clientRn}/update_parameter`;
  return await backend.post(url, values);
};

export default {
  OnboardingWebsocketManager,
  fetchFormData,
  updateParameter,
};
